import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { toast } from "react-toastify";

import { markBedCleaning } from "../api/ipdEnhancementsApi";

// Reused after allocation, transfer, and discharge to offer sending the
// just-vacated bed to housekeeping (status -> "cleaning").
export default function HousekeepingPrompt({
  open,
  onClose,
  bedCode,
  admissionId,
  onDone,
}) {
  const [submitting, setSubmitting] = useState(false);

  const handleConfirm = async () => {
    if (!bedCode) {
      onClose?.();
      return;
    }
    setSubmitting(true);
    try {
      const data = await markBedCleaning(bedCode, { admissionId });
      if (data?.status === "Success") {
        toast.success(data.message || `Bed ${bedCode} marked for cleaning`);
        onDone?.(data);
        onClose?.();
      } else {
        toast.error(data?.message || "Could not mark the bed for cleaning.");
      }
    } catch (err) {
      console.error("Mark cleaning failed:", err);
      toast.error(
        err?.response?.data?.message || "Could not mark the bed for cleaning."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 700 }}>Housekeeping</DialogTitle>
      <DialogContent>
        <Typography sx={{ fontSize: "14px" }}>
          Send bed <strong>{bedCode || "—"}</strong> for cleaning? It will be
          marked <em>cleaning</em> until housekeeping completes it.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>
          Not now
        </Button>
        <Button
          variant="contained"
          onClick={handleConfirm}
          disabled={submitting || !bedCode}
        >
          {submitting ? "Marking..." : "Mark for Cleaning"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
